import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faPersonChalkboard, faBookOpen, faComputer, faFilePdf, faMobileScreen} from "@fortawesome/free-solid-svg-icons";
import "../../TrainingPages.css";
import { Row, Col } from "react-bootstrap";

function ModuleLinks(props) {
    /**
     * Component for the bottom right card of the splash page (training/module links).
     * @param props: master JSON props passed down from the SplashPage component.
     * @returns: card containing all training links of the splash page training module
     */
    return (
        <div className="col-lg-6 d-flex p-md-1">
            <div className="card dark-bg1-sport w-100">
                <div className="card-body">
                    <div className="text-center">
                        <h3 className="card-titlext-center head-sport">Training Links</h3>
                        <h6 className="card-titlext-center head-sport">Click icon(s) to view:</h6> 
                    </div>
                    <br/>
                    <Row className="justify-content-center">
                        {Object.entries(props.moduleLinks).map(([linkType, entry]) => {
                            let icon;
                            // Assign icons to each module link JSON entry. Trainings may have more than one link, which is why
                            // a mapping is used here.
                            switch (linkType) {
                                case "Module":
                                    icon = faDesktop;
                                    break;
                                case "Microlesson":
                                    icon = faPersonChalkboard;
                                    break;
                                case "Quick Guide":
                                    icon = faBookOpen;
                                    break;
                                case "Interactive Quick Guide":
                                    icon = faComputer;
                                    break;
                                case "PDF":
                                    icon = faFilePdf;
                                    break;
                                case "Mobile Microlesson":
                                    icon = faMobileScreen;
                                    break;
                                default:
                                    console.error("Invalid Training Type Specified in Master JSON.");
                            }
                            return (
                                <Col key={linkType} className={"text-center"} md={"auto"}>
                                    <a href={entry} target="_blank" rel="noreferrer" >
                                        <FontAwesomeIcon icon={icon} className="fa-4x" style={{color: "lightblue"}}/>
                                    </a>
                                    <br/>
                                    <i className={"head-sport"}>{linkType}</i>
                                </Col>
                            );
                        })}
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default ModuleLinks;
